<template>
  <b-card class="delete-account-form" :title="header" :sub-title="subheader">
    <b-form
      class="form"
      onkeydown="return event.key != 'Enter'"
      @submit.prevent="verifyPassword"
    >
      <b-form-group>
        <custom-input
          type="password"
          placeholder="Password"
          v-model="form.password"
          autofocus
          required
          :disabled="form.$busy"
          :is-invalid="form.$getError('password')"
          @keyup.enter="verifyPassword"
        ></custom-input>
      </b-form-group>

      <error-message
        class="mb-2 mt-3"
        sign=""
        :error="form.$getError('password') || form.$errorMessage"
      ></error-message>

      <hr class="card-divider" />

      <div class="modal__footer">
        <p class="forgot-btn mt-3" @click="$refs.forgot.show()">
          Forgot Password?
        </p>
        <forgot-password-form ref="forgot"></forgot-password-form>

        <div class="modal__btns">
          <b-button
            variant="outline-secondary"
            :to="{ name: 'user.settings-page', params: { tab: 3 } }"
            >Discard</b-button
          >
          <b-button type="submit" variant="danger" :disabled="form.$busy">
            <b-spinner small v-if="form.$busy"></b-spinner>&nbsp;{{
              buttonText
            }}
          </b-button>
        </div>
      </div>
    </b-form>
  </b-card>
</template>
<script>
/**
 * ==================================================================================
 * Delete account form
 * ==================================================================================
 **/

import { mapActions } from 'vuex'
import Form from '@/utils/form'
import CustomInput from '@/components/inputs/CustomInput'
import ErrorMessage from '@/components/inputs/ErrorMessage'
import ForgotPasswordForm from '@/components/forms/ForgotPasswordForm.vue'

export default {
  components: {
    CustomInput,
    ErrorMessage,
    ForgotPasswordForm
  },
  data: function() {
    return {
      form: new Form({
        password: null
      }),

      header: 'Delete Account',
      subheader:
        'Are you sure you want to permanently delete your account? All details will be deleted.',
      buttonText: 'Confirm'
    }
  },
  methods: {
    ...mapActions({
      getVerificationToken: 'auth/getVerificationToken',
      deleteAccount: 'auth/deleteAccount',
      addAlert: 'alert/addAlert'
    }),

    async verifyPassword() {
      if (this.form.$busy) return
      this.form.$setLoading(true)
      await this.getVerificationToken({
        password: this.form.password
      })
        .then(() => {
          this.removeAccount()
        })
        .catch(error => {
          this.form.$setLoading(false)
          this.form.$handleError(error)
        })
    },

    removeAccount() {
      this.deleteAccount()
        .then(() => {
          this.$router.replace({
            name: 'home',
            params: {
              alert: {
                state: false,
                label: 'Your account has been deleted'
              }
            }
          })
        })
        .catch(error => {
          this.form.$setLoading(false)
          this.form.$handleError(error)
        })
    }
  }
}
</script>
<style scoped lang="scss">
.delete-account-form {
}
</style>
